import { EXPERIENCE } from "../../constants";
import useAppSelector from "../../hooks/useAppSelector";
export default function useIsRemarketingSearch() {
    var _a = useAppSelector(function (state) { return state.configuration; }), experience = _a.experience, policyOnly = _a.policyOnly;
    var isRemarketingSearch = experience === EXPERIENCE.REMARKETING && policyOnly === false;
    var isBundleRemarketingSearch = experience === EXPERIENCE.BUNDLE_REMARKETING;
    return isRemarketingSearch || isBundleRemarketingSearch;
}
